/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */

import { t } from '@sidekick/copy';
import { PageHeader } from '../components/PageHeader.js';
import { Review } from '../components/regions/Review.js';
import { today } from '../lib/ui.js';

/**
 * Weekly Review — the longer-horizon reflection surface.
 */
export function WeeklyReviewPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader label={t.nav.weeklyReview} />

      <div style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '40px 22px' }}>
        <div
          style={{
            width: '100%',
            maxWidth: 620,
            display: 'flex',
            flexDirection: 'column',
            gap: 40,
          }}
        >
          <Review weekEnd={today()} />
        </div>
      </div>
    </div>
  );
}
